import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';
import { RecurringPaymentInstruction } from '../../../../../../../models/submissions/recurring-payment-instruction';

@Component({
  selector: 'app-vb-payment-change-submission-scheduled-payment',
  templateUrl: './vb-payment-change-submission-scheduled-payment.component.html',
  styleUrls: ['../vb-payment-change-submission-recurring-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionScheduledPaymentComponent implements OnChanges {
  @Input({ required: true }) frequency!: VariableBenefitPaymentFrequencyEnum;
  @Input({ required: true }) scheduledRecurringPaymentInstruction!: RecurringPaymentInstruction;

  public paymentStartLabel: string = '';
  public paymentAmountType: string = '';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.scheduledRecurringPaymentInstruction) {
      this.paymentStartLabel = moment
        .utc(this.scheduledRecurringPaymentInstruction?.paymentStartDate)
        .format('MMMM, YYYY');
      this.paymentAmountType = this.scheduledRecurringPaymentInstruction?.useMinimumAmount
        ? $localize`Minimum`
        : $localize`Custom`;
    }
  }
}
